export class EnterpriseBankAccount {
  // tslint:disable-next-line:variable-name
  _id!: string;
  name!: string;
  address!: string;
  constructor() {
  }
}
